import React, { useState, useEffect } from "react";
import "./MainPage.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import UseLoggedinUser from "../../../hooks/UseLoggedInUser";
import CenterFocusWeakIcon from "@mui/icons-material/CenterFocusWeak";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import AddLinkIcon from "@mui/icons-material/AddLink";
import Post from "../../Feed/Post/Post";
import LockResetIcon from "@mui/icons-material/LockReset";
import axios from "axios";
import EditProfile from "../EditProfile/EditProfile";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { Avatar, Box, Button, Modal, TextField } from "@mui/material";
import TokenIcon from "@mui/icons-material/Token";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import InfoIcon from "@mui/icons-material/Info";
import VerifiedIcon from "@mui/icons-material/Verified";


const MainPage = ({ user }) => {
  const { t } = useTranslation();
  const { tweets } = t("mainPage");
  const [browserType, setBrowserType] = useState("");
  const [osType, setOsType] = useState("");
  const [deviceType, setDeviceType] = useState("");
  const [ipValue, setIpValue] = useState("");
  var isUserInfoVerfied = true;
  const [check, setCheck] = useState(false);
  const [postCount, setPostCount] = useState(0);
  const [isSubscribed, setIsSubscribed] = useState(0);
  const [likesCount, setLikesCount] = useState(0);
  const [upvotesCount, setUpvotesCount] = useState(0);
  const [misusing, setMisusing] = useState(false);
  const [subscrtiptonExpiry, setSubscrtiptonExpiry] = useState("");
  const [subscrtiptonType, setSubscrtiptonType] = useState("");
  // const [isSubscribedTo, setIsSubscribedTo] = useState(false);
  //email from user
  const email = user?.email;


  const navigate = useNavigate();
  const [loggedInUser] = UseLoggedinUser();
  const [posts, setPosts] = useState([]);
  const [imageURL, setImageURL] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const pi = loggedInUser[0]?.profileImage
    ? loggedInUser[0].profileImage
    : "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png";

  useEffect(() => {
    fetch(`https://twitter-qgxu.onrender.com/user/posts?email=${user?.email}`)
      .then((res) => res.json())
      .then((data) => {
        setPosts(data);
      });
  }, [posts, user?.email]);

  const { subsToPost, subscribe, whatsHappening, subsStatus, subsExpire, subsNot, limitReached, tweet } = t("tweetBox");
  const fetchData = async () => {
    try {

      const response = await fetch(`https://twitter-qgxu.onrender.com/auth/userInfo?email=${email}`);
      const data = await response.json();
      setBrowserType(data.userInfo.browser);
      setOsType(data.userInfo.os);
      setDeviceType(data.userInfo.device);
      setIpValue(data.userInfo.ip);
      isUserInfoVerfied = data.isBrowserVerified;
      // setCheck(true);
      console.log("Is broser Verified", data.isBrowserVerified);
      // console.log(isUserInfoVerfied);

    } catch (error) {
      console.log(error);
    }
  };

  // fetch data function should run upon opening this page for only once
  useEffect(() => {
    //after waiting for 2 seconds the fetchData should work
    setTimeout(() => {
      fetchData();
    }, 1000);
  }, []);



  const username = user?.email?.split("@")[0];

  const handleUploadCoverImage = (e) => {
    setIsLoading(true);
    const image = e.target.files[0];
    console.log(image);

    const formData = new FormData();
    formData.set("image", image);
    axios
      .post(
        "https://api.imgbb.com/1/upload?key=37fe4cb64c9314cb7d69dc88a1d6ff3f",
        formData
      )
      .then((res) => {
        const url = res.data.data.display_url;
        setImageURL(res.data.data.display_url);
        console.log(res.data.data.display_url);
        const useCoverImage = {
          email: user?.email,
          coverImage: url,
        };
        if (url) {
          axios.patch(
            `https://twitter-qgxu.onrender.com/user/userUpdates/${user?.email}`,
            useCoverImage
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  const handleUploadProfileImage = (e) => {
    setIsLoading(true);
    const image = e.target.files[0];
    console.log(image);

    const formData = new FormData();
    formData.set("image", image);
    axios
      .post(
        "https://api.imgbb.com/1/upload?key=37fe4cb64c9314cb7d69dc88a1d6ff3f",
        formData
      )
      .then((res) => {
        const url = res.data.data.display_url;
        setImageURL(res.data.data.display_url);
        console.log(res.data.data.display_url);
        const useprofileImage = {
          email: user?.email,
          profileImage: url,
        };
        if (url) {
          axios.patch(
            `https://twitter-qgxu.onrender.com/user/userUpdates/${user?.email}`,
            useprofileImage
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    const fetchD = async () => {
      try {
        const response = await fetch(`https://twitter-qgxu.onrender.com/auth/userStatus?email=${email}`);
        const data = await response.json();
        setPostCount(data.postCount);
        setIsSubscribed(data.isSubscribed);
        setLikesCount(data.totalLikes);
        setUpvotesCount(data.totalUpvotes);
        setMisusing(data.isMisusing);
        const date = new Date(data.subscriptionExpiry);
        const formattedDate = date.toLocaleDateString();
        setSubscrtiptonExpiry(formattedDate);
        if (data.isSubscribed === 2) {
          setSubscrtiptonType("Yearly");
        } else if (data.isSubscribed === 1) {
          setSubscrtiptonType("Monthly");
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchD();
  }
    , [email]);

  return (
    <div>
      <ArrowBackIcon
        className="arrow-icon"
        onClick={() => {
          navigate("/");
        }}
      />
      <h4 className="heading-4">@{username}</h4>
      <div className="mainProfile">
        <div className="profile-bio">
          {
            <div>
              <div className="coverImageContainer">
                <img
                  src={
                    loggedInUser[0]?.coverImage
                      ? loggedInUser[0].coverImage
                      : "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
                  }
                  alt="cover"
                  className="coverImage"
                />
                <div className="hoverCoverImage">
                  <label htmlFor="image" className="imageIcon">
                    {isLoading ? (
                      <LockResetIcon className="photoIcon photoIconDisabled" />
                    ) : (
                      <CenterFocusWeakIcon className="photoIcon" />
                    )}
                  </label>
                  <div className="imageIcon_tweetButton">
                    <input
                      type="file"
                      id="image"
                      className="imageInput"
                      onChange={handleUploadCoverImage}
                    />
                  </div>
                </div>
              </div>
              <div className="avatar-img">
                <div className="avatarContainer">
                  <img
                    src={
                      loggedInUser[0]?.profileImage
                        ? loggedInUser[0].profileImage
                        : "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_960_720.png"
                    }
                    alt="cover"
                    className="avatar"
                  />
                  <div className="hoverAvatarImage">
                    <label htmlFor="profileImage" className="imageIcon">
                      {isLoading ? (
                        <LockResetIcon className="photoIcon photoIconDisabled" />
                      ) : (
                        <CenterFocusWeakIcon className="photoIcon" />
                      )}
                    </label>
                    <div className="imageIcon_tweetButton">
                      <input
                        type="file"
                        id="profileImage"
                        className="imageInput"
                        onChange={handleUploadProfileImage}
                      />
                    </div>
                  </div>
                </div>
                <div className="userInfo">
                  <div>
                    <h3 className="heading-3">
                      {loggedInUser[0]?.name
                        ? loggedInUser[0]?.name
                        : user && user?.displayName}
                    </h3>
                    <p className="usernameSection"> @{username}</p>
                  </div>
                  <EditProfile user={user} loggedInUser={loggedInUser} />
                </div>
                {isSubscribed ?
                  <div style={{ display: "flex" }}>
                    <Tooltip
                      title={`${postCount > 1000 ? `${postCount} posts` : `${postCount} posts`}`}
                    >
                      {postCount > 1000 ? (
                        <TokenIcon style={{ color: 'black' }} />
                      ) : postCount > 50 ? (
                        <TokenIcon style={{ color: 'gray' }} />
                      ) : null}
                    </Tooltip>

                    <Tooltip
                      title={`${likesCount > 10000 ? `${likesCount} likes` : `${likesCount} likes`}`}
                    >
                      {likesCount > 50000 ? (
                        <FavoriteIcon style={{ color: 'red' }} />
                      ) : likesCount > 10000 ? (
                        <FavoriteIcon style={{ color: 'magenta' }} />
                      ) : null}
                    </Tooltip>


                    <Tooltip
                      title={`${upvotesCount > 50000 ? `${upvotesCount} upvotes` : `${upvotesCount} upvotes`}`}
                    >
                      {upvotesCount > 50000 ? (
                        <ThumbUpIcon style={{ color: 'blue' }} />
                      ) : upvotesCount > 10000 ? (
                        <ThumbUpIcon style={{ color: 'green' }} />
                      ) : null
                      }
                    </Tooltip>

                    <Tooltip
                      title={`${misusing ? 'Misusing! Please refraim from spamming to enable access to posts again' : 'Not Misusing'}`}
                    >
                      {misusing ? (
                        <ThumbDownOffAltIcon style={{ color: 'red' }} />
                      ) : null}
                    </Tooltip>

                    <Tooltip title={`${subsStatus}${isSubscribed ? `${subscrtiptonType}${subsExpire}${subscrtiptonExpiry}` : `${subsNot} ${10 - postCount}`}`}>
                      <VerifiedIcon style={{ color: '#1DA1F2' }} />
                    </Tooltip>
                  </div>
                  :
                  <div>
                    <Tooltip
                      title={`${postCount > 1000 ? `${postCount} posts` : `${postCount} posts`}`}
                    >
                      {postCount > 1000 ? (
                        <TokenIcon style={{ color: 'black' }} />
                      ) : postCount > 50 ? (
                        <TokenIcon style={{ color: 'gray' }} />
                      ) : null}
                    </Tooltip>

                    <Tooltip
                      title={`${likesCount > 10000 ? `${likesCount} likes` : `${likesCount} likes`}`}
                    >
                      {likesCount > 50000 ? (
                        <FavoriteIcon style={{ color: 'red' }} />
                      ) : likesCount > 10000 ? (
                        <FavoriteIcon style={{ color: 'magenta' }} />
                      ) : null}
                    </Tooltip>


                    <Tooltip
                      title={`${upvotesCount > 50000 ? `${upvotesCount} upvotes` : `${upvotesCount} upvotes`}`}
                    >
                      {upvotesCount > 50000 ? (
                        <ThumbUpIcon style={{ color: 'blue' }} />
                      ) : upvotesCount > 10000 ? (
                        <ThumbUpIcon style={{ color: 'green' }} />
                      ) : null
                      }
                    </Tooltip>

                    <Tooltip
                      title={`${misusing ? 'Misusing! Please refraim from spamming to enable access to posts again' : 'Not Misusing'}`}
                    >
                      {misusing ? (
                        <ThumbDownOffAltIcon style={{ color: 'red' }} />
                      ) : null}
                    </Tooltip>

                    <Tooltip title={`${subsStatus}${isSubscribed ? `${subscrtiptonType}${subsExpire}${subscrtiptonExpiry}` : `${subsNot} ${10 - postCount}`}`}>
                      <InfoIcon />
                    </Tooltip>

                  </div>
                }
                <div className="infoContainer">
                  Browser : {browserType ? browserType : "Not Available"}
                  <br />
                  OS : {osType ? osType : "Not Available"}
                  <br />
                  Device : {deviceType ? deviceType : "Not Available"}
                  <br />
                  IP : {ipValue ? ipValue : "Not Available"}
                  <br />
                  Bio : {loggedInUser[0]?.bio ? loggedInUser[0]?.bio : ""}
                  {/* status of user */}
                  {/* likes */}
                  <br />
                  <hr />
                  <div className="statusContainer">
                    {postCount} {t("posts")}
                    <br />
                    {likesCount} {t("likes")}
                    <br />
                    {upvotesCount} {t("upvotes")}
                    <br />
                    {isSubscribed === 0 ? "Not Subscribed" : "Subscribed"}
                    <br />
                    {subscrtiptonType} Subscription
                    <br />
                    Subscription Expires on {subscrtiptonExpiry}
                  </div>
                  <div className="loactionAndLink">
                    {loggedInUser[0]?.location ? (
                      <p className="subInfo">
                        <MyLocationIcon /> {loggedInUser[0]?.location}
                      </p>
                    ) : (
                      ""
                    )}
                    {loggedInUser[0]?.website ? (
                      <p className="subInfo link">
                        <AddLinkIcon /> {loggedInUser[0]?.website}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <h4 className="tweetsText">{tweets}</h4>
                <hr />
              </div>
              {posts.map((p) => (
                <Post id={p._id} p={p} />
              ))}
            </div>
          }
        </div>
      </div>
    </div >
  );
};

export default MainPage;
